import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const createShortcutMessage = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/shortcut-message`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const updateShortcutMessage = async (token, payload) => {
  const { data: response } = await axios.put(`${apiUrl}/shortcut-message`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const deleteShortcutMessage = async (token, id) => {
  const { data: response } = await axios.delete(`${apiUrl}/shortcut-message/${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getShortcutMessages = async (token, query) => {
  const { data: response } = await axios.get(`${apiUrl}/shortcut-messages?${query}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getShortcutMessage = async (token, id) => {
  const { data: response } = await axios.get(`${apiUrl}/shortcut-message?id=${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}
